import React, {Component, PropTypes} from 'react';
import ReactDOM from 'react-dom';
import {Link} from 'react-router'
import {connect} from 'react-redux';
import Frame2 from '../components/Frame2';
import CodeMirrorItem from '../components/CodeMirrorItem';
import {demos, examples, config} from '../../.temp/asset';
import {generateIframePageHtmlAndReference, getHtmlString } from '../utils/domUtils';
import ReactTabs from 'react-tabs';
import translate from '../../i18n/translate';
import _ from 'lodash';
import {version} from '../utils/domUtils';
var Tab = ReactTabs.Tab;
var Tabs = ReactTabs.Tabs;
var TabList = ReactTabs.TabList;
var TabPanel = ReactTabs.TabPanel;
import DemoGallery from '../components/DemoGallery';
import {loadDemoList, handleViewportResize, filterDemoList, toggleNaviTree, expandNaviTree, updateUserLang} from '../actions';
import { hashHistory  } from 'react-router';


function applyContent(value) {
    var contentHTML = '';
    if (value) {
        var elements = [], subItems;
        elements.push("<div class='sample-content'><h1 class='sample-title'>" + value.title + "</h1>");
        var segments = value.segments;
        if (segments) {
            segments.forEach(function (segment) {
                if (segment) {
                    segment.forEach(function (item) {
                        if (item) {
                            if (item.description) {                              //description
                                elements.push("<p>" + item.description + "</p>");
                            } else if (item.list && item.list.length > 0) {      // list
                                subItems = item.list.map(function (listItem) {
                                    return "<li><b>" + listItem + "</b></li>";
                                }).join("");
                                elements.push("<ul>" + subItems + "</ul>");
                            } else if (item.text && item.text.length > 0) {
                                var result = _.chunk(item.text, 6);
                                var dom = '';
                                var index = Math.floor(item.index / 6);
                                for(var i = 0; i < result.length; i++) {
                                    if(i === (result.length - 1)) {
                                        result[i][1] = result[i][1] ? result[i][1] : "";
                                        result[i][2] = result[i][2] ? result[i][2] : "";
                                        result[i][3] = result[i][3] ? result[i][3] : "";
                                        result[i][4] = result[i][4] ? result[i][4] : "";
                                        result[i][5] = result[i][5] ? result[i][5] : "";
                                    }
                                    if(i >= index) {
                                        if (i === index) {
                                            var len = item.index - 6 * Math.floor(item.index / 6);
                                            dom += "<tr>";
                                            for (var j = 0; j < len; j++) {
                                                dom += "<th class = 'table-th'>" + result[i][j] + "</th>";
                                            }
                                            for (j = len; j < 6; j++) {
                                                dom += "<th class = 'table-th-new'>" + result[i][j] + "</th>";
                                            }
                                            dom += "</tr>";
                                        } else {
                                            dom += "<tr><th class = 'table-th-new'>" + result[i][0] + "</th><th class='table-th-new'>" + result[i][1] + "</th><th class='table-th-new'>" + result[i][2] +
                                                "</th><th class='table-th-new'>" + result[i][3] + "</th><th class='table-th-new'>" + result[i][4] + "</th><th class='table-th-new'>" + result[i][5] + "</th></tr>"
                                        }
                                    }
                                    else {
                                            dom += "<tr><th class = 'table-th'>" + result[i][0] + "</th><th class='table-th'>" + result[i][1] + "</th><th class='table-th'>" + result[i][2] +
                                            "</th><th class='table-th'>" + result[i][3] + "</th><th class='table-th'>" + result[i][4] + "</th><th class='table-th'>" + result[i][5] + "</th></tr>"
                                    }
                                }
                                elements.push("<table border=1 class='table-style'>" + dom + "</table>");
                            }else if (item.code && item.code.length > 0) {      //code
                                subItems = item.code.map(function (lineCode) {
                                    return lineCode ?
                                        lineCode.replace(/\</g, "&lt;").replace(/\>/g, "&gt;")
                                        : "";
                                }).join("\n");
                                var codeType = subItems.indexOf("&lt;html") >= 0 || subItems.indexOf("&lt;link") >= 0 ? "html" : "js";
                                elements.push("<pre class='sample-code'><code class='" + codeType + "'>" + subItems + "</code></pre>");
                            }
                        }
                    });
                }
            });
        }
        elements.push("<div class='sample-content-end'></div></div>");
        contentHTML = elements.join("");
    }
    return contentHTML;
}

var newContent;
var licenseStr = '<script src="js/spread/license.js" type="text/javascript"></script>';
const bodyStyle = 'style="margin:0;position:absolute;top:0;bottom:0;left:0;right:0;font-size:14px;user-select:none;-webkit-user-select: none;overflow:hidden;font-family:-apple-system, BlinkMacSystemFont, \'Segoe UI\', Roboto, Helvetica, Arial, sans-serif, \'Apple Color Emoji\', \'Segoe UI Emoji\', \'Segoe UI Symbol\'"';

class DemoPage extends Component {
    constructor(props) {
        super(props);
        this.state = {index:0,isMobileShowTab:false};
        this.demoDetail = null;
        this.reference = null;
        const userAgent = navigator.userAgent;
        var regex = /iPad|iPhone|Android/i;
        var isTouchDevice = (regex.test(userAgent)) && (window.screen.width <= 768 || window.screen.height <= 768);
        this.isMobile = isTouchDevice;
    }

    componentWillMount() {
        const demoId = this.props.params && this.props.params.demoId;
        this.demoDetail =this.props.demoDetails[demoId] || null;
    }

    componentWillReceiveProps(nextProps) {
        const demoId = nextProps.params && nextProps.params.demoId;
        this.demoDetail = nextProps.demoDetails[demoId] || null;
    }

    updateCode(newCode) {
        newContent = newCode;
    }

    generateHTMLPage(demoDetails, resource) {
        var renderPars = {
            inlineStyle: demoDetails.inlineCSS,
            htmlBody: demoDetails.bodyContent,
            template: demoDetails.template,
            inlineScript: demoDetails.entryJs,
            dependencies: demoDetails.dependencies,
            htmlBodyStyle: bodyStyle,
        };
        let htmlObj =  generateIframePageHtmlAndReference(renderPars, false, false, resource, false);
        let reference = htmlObj.reference;
        this.reference = reference.replace(licenseStr,'');//delete licenseStr
        return htmlObj.htmlString;
    }

    setFocusContent() {
        var iframeElement = document.querySelector('iframe');

        if (iframeElement) {
            var element = iframeElement.contentWindow.document.querySelector('#grid1');
            if (element) {
                element.focus();
            }
        }
        $('pre code').each(function (i, block) {
            hljs.highlightBlock(block);
        });
    }

    componentDidMount() {
        setTimeout(this.setFocusContent, 100);
    }

    componentDidUpdate() {
        setTimeout(this.setFocusContent, 100);
    }

    handleRunBtnClick(e) {
        let container = ReactDOM.findDOMNode(this.refs.demoframe);
        let liveEditFrame = container.children[0];
        let doc = liveEditFrame.contentWindow.document;
        try {
            if(this.changeCss || this.changeReference) {
                let content = this.getHtmlStringByDemoDetail(this.demoDetail, true);
                doc.open();
                doc.write(content || '');
                doc.close();
                this.changeReference = false;
                this.changeCss = false;
            } else if(this.changeHtml || this.changeJS) {
                let body = doc.body;
                body.getElementsByClassName('sample-tutorial')[0].parentElement.innerHTML = this.demoDetail.bodyContent;
                let scriptNewTag = document.createElement('script');
                scriptNewTag.text = this.demoDetail.entryJs;
                body.appendChild(scriptNewTag);
                this.changeJS = false;
                this.changeHtml = false;
                $(doc).ready(()=>{
                    if (liveEditFrame.contentWindow && liveEditFrame.contentWindow.onload) {
                        liveEditFrame.contentWindow.onload();
                    }
                });
            }
        } catch (e) {

        }
    }

    getHtmlStringByDemoDetail(demoDetail, adaptMobileDev) {
        let renderPars = {
            inlineStyle: demoDetail.inlineCSS,
            htmlBody: demoDetail.bodyContent,
            template: demoDetail.template,
            inlineScript: demoDetail.entryJs,
            dependencies: demoDetail.dependencies,
            htmlBodyStyle: bodyStyle,
        };
        let newContent = getHtmlString(renderPars , this.reference, adaptMobileDev);
        if(newContent){
            return adaptMobileDev ? newContent.slice(0, newContent.indexOf("<style>")) + licenseStr + '\n' + newContent.slice(newContent.indexOf("<style>"), newContent.length) : newContent;
        }else{
            return null;
        }
    }

    getNewContentByDemoDetail(demoDetail) {
        if(demoDetail){
            return this.generateHTMLPage(demoDetail, demoDetail.id && demoDetail.bodyIntls);
        }
        return null;
    }

    changeContentIndex(index) {
        this.setState({
            index:index
        });
        if(this.isMobile){
            this.changeMobileIsShowTab(true);
        }
    }

    mobileHideTab(){
        if(this.isMobile){
            this.changeMobileIsShowTab(false);
        }
    }

    changeMobileIsShowTab(isShow){
        this.setState({
            isMobileShowTab:isShow
        });
        let dom = document.getElementById('titleNav');
        if(isShow){
            dom.style.display = 'none';
        }else{
            dom.style.display = 'flex';
        }
    }
    handleDownloadBtnClick(e) {
        var replaceLocalResource = function (code) {
            var localCssResource = ['gc.spread.sheets.excel2013white.' + version + '.css',
                'nouislider.min.css'
            ];

            var localJsResource = [
                'gc.spread.sheets.all.' + version + '.min.js',
                'jquery-1.8.2.min.js',
                'nouislider.min.js',
                'echarts.js',
                'globalize.min.js',
                'globalize.cultures.js',
                'gc.spread.excelio.' + version + '.min.js',
                'gc.spread.sheets.print.' + version + '.min.js',
                'gc.spread.sheets.pdf.' + version + '.min.js',
                'gc.spread.sheets.charts.' + version + '.min.js',
                'gc.spread.sheets.barcode.' + version + '.min.js',
                'gc.spread.sheets.shapes.' + version + '.min.js',
                'FileSaver.js',
                'gc.spread.sheets.resources.ja.' + version + '.min.js',
                'gc.spread.sheets.resources.zh.' + version + '.min.js',
                'gc.spread.sheets.resources.ko.' + version + '.min.js',
            ];
            var versionTemp = version;
            var cdnCssResource = [
                'http://cdn.grapecity.com/spreadjs/hosted/css/' + 'gc.spread.sheets.excel2013white.' + versionTemp + '.css',
                'https://cdnjs.cloudflare.com/ajax/libs/noUiSlider/8.1.0/nouislider.min.css'
            ];

            var cdnJsResource = [
                'http://cdn.grapecity.com/spreadjs/hosted/scripts/gc.spread.sheets.all.' + versionTemp + '.min.js',
                'http://code.jquery.com/jquery-1.8.2.min.js',
                "https://cdnjs.cloudflare.com/ajax/libs/noUiSlider/8.1.0/nouislider.min.js",
                "http://echarts.baidu.com/build/dist/echarts-all.js",
                "https://cdnjs.cloudflare.com/ajax/libs/globalize/0.1.1/globalize.min.js",
                "https://cdnjs.cloudflare.com/ajax/libs/globalize/0.1.1/cultures/globalize.cultures.min.js",
                'http://cdn.grapecity.com/spreadjs/hosted/scripts/plugins/gc.spread.excelio.' + versionTemp + '.min.js',
                'http://cdn.grapecity.com/spreadjs/hosted/scripts/plugins/gc.spread.sheets.print.' + versionTemp + '.min.js',
                'http://cdn.grapecity.com/spreadjs/hosted/scripts/plugins/gc.spread.sheets.pdf.' + versionTemp + '.min.js',
                'http://cdn.grapecity.com/spreadjs/hosted/scripts/plugins/gc.spread.sheets.charts.' + versionTemp + '.min.js',
                'http://cdn.grapecity.com/spreadjs/hosted/scripts/plugins/gc.spread.sheets.barcode.' + versionTemp + '.min.js',
                'http://cdn.grapecity.com/spreadjs/hosted/scripts/plugins/gc.spread.sheets.shapes.' + versionTemp + '.min.js',
                '//cdn.bootcss.com/FileSaver.js/2014-11-29/FileSaver.js',
                'http://cdn.grapecity.com/spreadjs/hosted/scripts/resources/ja/gc.spread.sheets.resources.ja.' + versionTemp + '.min.js',
                'http://cdn.grapecity.com/spreadjs/hosted/scripts/resources/zh/gc.spread.sheets.resources.zh.' + versionTemp + '.min.js',
                'http://cdn.grapecity.com/spreadjs/hosted/scripts/resources/ko/gc.spread.sheets.resources.ko.' + versionTemp + '.min.js',
            ];

            for (var i = 0; i < localCssResource.length; i++) {
                var index = code.indexOf(localCssResource[i]);
                if(index >= 0) {
                    var cssStart = index + localCssResource[i].length;
                    var hrefStart = code.substring(0, cssStart).lastIndexOf('href');
                    var left = code.substring(0, hrefStart) + 'href="';
                    var right = code.substring(cssStart);
                    code = left + cdnCssResource[i] + right;
                }
            }
            for (i = 0; i < localJsResource.length; i++) {
                var index = code.indexOf(localJsResource[i]);
                if(index >= 0) {
                    var jsStart = code.indexOf(localJsResource[i]) + localJsResource[i].length;
                    var srcStart = code.substring(0, jsStart).lastIndexOf('src');
                    left = code.substring(0, srcStart) + 'src="';
                    right = code.substring(jsStart);
                    code = left + cdnJsResource[i] + right;
                }
            }
            return code;
        };
        var images = ["Calories.png", "Food.png", "Minutes_bottom.png", "Minutes_top.png", "Servings_bottom.png", "Servings_top.png", "Titile_TL.png", "Titile_TR.png"]
        const demoId = this.props.params && this.props.params.demoId;
        if(demoId){
            let filename = demoId + '.html', code = this.getHtmlStringByDemoDetail(this.demoDetail);
            if(code){
                if (code !== '' && filename !== '') {
                    // remove local resource, use cdn
                    var fixedCode = replaceLocalResource(code);
                    var downloadCode = fixedCode;
                    var dataSource = fixedCode.match(/src="data\/\w+\.js"/g);
                    var str, str1;
                    if(dataSource && dataSource.length > 0) {
                        for(var i = 0; i < dataSource.length; i++) {
                            str = dataSource[i];
                            str1 = str.replace('data/', './');
                            downloadCode = downloadCode.replace(str, str1);
                        }
                    }

                    if (window.ActiveXObject !== undefined) {
                        console.log(window.ActiveXObject);
                        var myFrame = document.createElement('iframe');
                        myFrame.style.display = "none";
                        document.body.appendChild(myFrame);
                        var contentDocument = myFrame.contentDocument;
                        contentDocument.open("text/html", "replace");
                        contentDocument.write(downloadCode);
                        contentDocument.close();
                        contentDocument.execCommand('SaveAs', true, filename);
                        document.body.removeChild(myFrame);
                    } else {

                        var alink = document.createElement('a');
                        alink.style.display = 'none';
                        document.body.appendChild(alink);
                        var blob = new Blob([downloadCode], {type: 'text/html'});
                        var urlContent = URL.createObjectURL(blob);
                        alink.setAttribute('download', filename);
                        alink.setAttribute('href', urlContent);
                        alink.click();
                        setTimeout(function () {
                            if(dataSource && dataSource.length > 0) {
                                for(i = 0; i < dataSource.length; i++) {
                                    str = dataSource[i];
                                    var file = str.slice(str.indexOf('/') + 1, str.indexOf('.js'));
                                    alink.setAttribute('download', file + ".js");
                                    alink.setAttribute('href', "data/" + file + ".js");
                                    alink.click();                                                        }
                            }
                            if(demoId === "cookbook") {
                                images.forEach(function (imageName) {
                                    alink.setAttribute('download', "css/images/" + imageName);
                                    alink.setAttribute('href', "css/images/" + imageName);
                                    alink.click();
                                })
                            }
                        }, 500);
                        document.body.removeChild(alink);
                        return true;
                    }
                }
            }
        }

    }

    handleJumpPage() {
        this.props.expandNaviTree("level0_2");
    }

    render() {
        newContent = null;
        let result;

        const demoId = this.props.params && this.props.params.demoId;
        const {strings} = this.props;
        const demoIntl = strings.demo_intl;
        const viewportHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
        let minHeight = viewportHeight - 235;
        if (document.documentElement.clientWidth < 768) {
            minHeight += 60;
        }
        if (demoId) {
            const demoDetail = this.props.demoDetails[demoId];
            if (!demoDetail) {
                hashHistory.replace('/#/demos/initializeSpread');
                // result = <h1>loading failed</h1>;
            } else {
                let htmlSource = this.generateHTMLPage(demoDetail, demoIntl[demoDetail.id] && demoIntl[demoDetail.id].bodyIntls,);
                var description = applyContent(demoIntl[demoDetail.id].description || demoDetail.description);
                newContent = this.getNewContentByDemoDetail(demoDetail);
                let content;
                let options;
                switch (this.state.index){
                    case 0 :
                        content = <div className="demo-description-container">
                            <div key={demoDetail.id + 'Desp'} className="description"
                                 dangerouslySetInnerHTML={{__html: description}}/></div>;
                        break;
                    case 1 :
                        options = {
                            lineNumbers: true,
                            mode: 'htmlmixed',
                            viewportMargin: Infinity,
                            foldGutter: true,
                            gutters: ['CodeMirror-linenumbers', 'CodeMirror-foldgutter']
                        };
                        content = <CodeMirrorItem  htmlContent={demoDetail.bodyContent} updateCode={(bodyContent)=>{this.demoDetail.bodyContent = bodyContent; this.changeHtml = true;}} options = {options}/>;
                        break;
                    case 2:
                        options = {
                            lineNumbers: true,
                            mode: 'javascript',
                            viewportMargin: Infinity,
                            foldGutter: true,
                            gutters: ['CodeMirror-linenumbers', 'CodeMirror-foldgutter']
                        };
                        content = <CodeMirrorItem  htmlContent={demoDetail.entryJs} updateCode={(entryJs)=>{this.demoDetail.entryJs = entryJs; this.changeJS = true;}} options = {options}/>;
                        break;
                    case 3:
                        options = {
                            lineNumbers: true,
                            mode: 'css',
                            viewportMargin: Infinity,
                            foldGutter: true,
                            gutters: ['CodeMirror-linenumbers', 'CodeMirror-foldgutter']
                        };
                        content = <CodeMirrorItem  htmlContent={demoDetail.inlineCSS || ''} updateCode={(style)=>{this.demoDetail.inlineCSS = style; this.changeCss = true;}} options = {options}/>;
                        break;
                    case 4:
                        options = {
                            lineNumbers: true,
                            mode: 'htmlmixed',
                            viewportMargin: Infinity,
                            foldGutter: true,
                            gutters: ['CodeMirror-linenumbers', 'CodeMirror-foldgutter']
                        };
                        content = <CodeMirrorItem  htmlContent={this.reference || ''} updateCode={(reference)=>{this.reference = reference; this.chageReference = true;}} options = {options}/>;
                        break;
                    default:
                        content = '';
                        break;
                }
                result = <div className='mainContent'>
                    <div className='descriptionWrapper'>
                        <div ref="demoframe" className={demoDetail.id === 'filterDialog' ? 'demo-frame-container-special' : "demo-frame-container"}>
                            <Frame2 key={demoDetail.id} htmlContent={htmlSource}/>
                        </div>

                        <div className="demo-code-container">
                            <ContentContener
                                handleDownloadBtnClick = {()=>{this.handleDownloadBtnClick()}}
                                activeIndex = {this.state.index}
                                changeContentIndex = {(index)=>{this.changeContentIndex(index)}}
                                strings = {strings}
                                runCode = {()=>{this.handleRunBtnClick()}}/>
                            {this.isMobile?'':
                                <DemoDatils
                                    isDescription = {this.state.index === 0}
                                    content = {content}
                            />}
                        </div>
                        {this.isMobile?
                            <DemoDatilsMobile
                            content = {content}
                            isShow = {this.state.isMobileShowTab}
                            isDescription = {this.state.index === 0}
                            mobileHideTab={()=>{this.mobileHideTab()}}
                            handleRunBtnClick = {()=>{this.handleRunBtnClick()}}
                            isMobile = {this.isMobile}
                            strings = {strings}
                            />:''
                        }
                    </div>
                </div>;
                this.state.index = 0;
            }
        } else {
            result = <div className="mianContent">
                <DemoGallery onTest = {(link)=>{this.handleJumpPage(link)}}/>
            </div>;

            {/*result = <div className='mainContent'><p>{strings.Description}*/}
            // </p></div>;
        }

        return (
            <div className="container-wrapper-page">
                {result}
            </div>
        );
    }
}

DemoPage.propTypes = {
    demoDetails: PropTypes.object,
    groupName: PropTypes.string
};

DemoPage.defaultProps = {
    demoDetail: null,
    strings: {}
};

function getDemoList(state, ps) {
    var filterResults = (ps.route.groupName === 'demos') ? demos.demoList : examples.demoList;
    const {filterString} = state;
    const filter = filterString && filterString.filter && filterString.filter.toLowerCase();

    if (filter) {
        var result = getDemoItems(filter, filterResults);
        if (result.length <= 0) {
            _.each(filterResults, function (group) {
                var itemResult = getDemoItems(filter, group.children);
                if(itemResult.length > 0) {
                    result.push({
                        title: group.title,
                        id: group.id,
                        children: itemResult
                    });
                }
            });
        }
        filterResults = result;
    }
    return filterResults;
}

function getDemoItems(filter, group) {
    var itemResult = [];

    var filteredGroupItmes = _.filter(group, function (item) {
        return item.title.toLowerCase().indexOf(filter) >= 0 || (item.keywords && _.find(item.keywords, function (keyword) {
                return keyword.toLowerCase().indexOf(filter) >= 0;
            }));
    });

    if (filteredGroupItmes.length > 0) {
        return filteredGroupItmes;
    }


    _.each(group, function (subGroup) {
        filteredGroupItmes = _.filter(subGroup.children, function (item) {
            return item.title.toLowerCase().indexOf(filter) >= 0 || (item.keywords && _.find(item.keywords, function (keyword) {
                    return keyword.toLowerCase().indexOf(filter) >= 0;
                }));
        });

        if (filteredGroupItmes.length > 0) {
            itemResult.push({
                title: subGroup.title,
                id: subGroup.id,
                level: subGroup.level,
                children: filteredGroupItmes
            });
        }
    });
    return itemResult;
}

class DemoDatilsMobile extends Component{
    render(){
        let content;
        content = <div className="hidden-desktop demoDatils">
            <DemoDetailsHead
                isDescription = {this.props.isDescription}
                mobileHideTab = {()=>{this.props.mobileHideTab()}}
                handleRunBtnClick = {()=>{this.props.handleRunBtnClick()}}
                strings = {this.props.strings}
            />
            <div className="demoDetailsCodeMirror" style = {{overflow:this.props.isDescription?'scroll':'hidden'}}>
                <div className="middleHeadAndCodeMirror"/>
                <div className="codeMirrorItemContent">{this.props.content}</div>
            </div>
        </div>

        let isHideTabItem = !this.props.isShow && this.props.isMobile;
        return(
            <div style = {{height:'100%',overflow:'hidden',display:isHideTabItem?'none':'block',border:this.props.isMobile?'':'solid 1px #cccccc'}}>
                {content}
            </div>
        );
    }
}

class DemoDatils extends Component{
    render(){
        return(
            <div style = {{height:'100%',overflow:'hidden',border:'solid 1px #cccccc'}}>
                <div className="codeMirrorItemContent hidden-mobile" style={{overflow:this.props.isDescription ?'auto':'hidden'}}>{this.props.content}</div>
            </div>
        );
    }
}

class DemoDetailsHead extends Component{

    render(){
        return(
            <div className="demoDetailsHead">
                <div className="toolbar navbar">
                    <div className="toolbar-section toolbar-section--left">
                        <div className="action" role="button" onClick={() => this.props.mobileHideTab()}>
                            <svg fill="currentColor" height="24" viewBox="0 0 24 24" width="24"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/>
                            </svg>
                        </div>
                    </div>
                    <div className="toolbar-section toolbar-section--right">
                        {!this.props.isDescription &&
                        <div className="action"
                             role="button"
                             onClick={()=>{
                                 this.props.handleRunBtnClick();
                                 this.props.mobileHideTab();
                             }}>
                            <span>{this.props.strings.Run}</span>
                            <svg fill="currentColor" height="24" viewBox="0 0 24 24" width="24"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path d="M8 5v14l11-7z"/>
                            </svg>
                        </div>
                        }
                    </div>
                </div>
            </div>
        );
    }
}

class ContentContener extends Component{
    changeContentIndex(index) {
        this.props.changeContentIndex(index);
    }
    render(){
        let { strings, activeIndex } = this.props;
        return(
            <div className="ContentContener">
                <div className={'header' + ' ' + (activeIndex == 0?'activeHeader':'')} onClick={()=>{this.changeContentIndex(0)}}>{strings.desiriptionTabDesc}</div>
                <div className={'header' + ' ' + (activeIndex == 1?'activeHeader':'')} onClick={()=>{this.changeContentIndex(1)}}>{strings.html}</div>
                <div className={"header" + ' ' + (activeIndex == 2?'activeHeader':'')} onClick={()=>{this.changeContentIndex(2)}}>{strings.JavaScript}</div>
                <div className={"header" + ' ' + (activeIndex == 3?'activeHeader':'')} onClick={()=>{this.changeContentIndex(3)}}>{strings.css}</div>
                <div className={"header hidden-mobile" + ' ' + (activeIndex == 4?'activeHeader':'')} onClick={()=>{this.changeContentIndex(4)}}>{strings.resource}</div>
                <div className="runButton hidden-mobile">
                    <button type="button" className="runButtonItem"
                            onClick={() => this.props.runCode()}>
                        <i className="fa fa-play"/>
                        {strings.Run}
                    </button>
                    <button type="button" className="downloadButton"
                            title="Download demo"
                            onClick={(e) => this.props.handleDownloadBtnClick(e)}>
                        <i className="fa fa-download"></i>
                        <span>{strings.Download}</span>
                    </button>
                </div>
            </div>
        );
    }
}

const stateToProps = (state, ps) => ({
    groupName: ps.route.groupName,
    demoDetails: (ps.route.groupName === 'demos') ? demos.demoDetails : examples.demoDetails,
    demoList: getDemoList(state, ps)
});

const decorators = _.flow([
    connect(stateToProps,  {toggleNaviTree, expandNaviTree}),
    translate('DemoPage')
]);

export default decorators(DemoPage);



// WEBPACK FOOTER //
// ./client/containers/DemoPage.js